/** The count of a `WorkCount` as React state. */
import { useSyncExternalStore } from 'react';
export function usePendingWork(work) {
    return useSyncExternalStore(work.subscribe, work.pending, work.pending);
}
//# sourceMappingURL=usePendingWork.js.map